import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Handle, Position } from 'reactflow';
import { Button, Popover } from 'antd';
import { Image } from 'react-bootstrap';
import './nodeStyles.css';
import addIcon from "../../assets/icons/addNodes.svg";
import removeIcon from "../../assets/icons/removeNodes.svg";
import { findNextNode } from '../../utilities/Nodes/getConnectedChildNodes';
import { ChoiceNodeProps } from '../../utilities/types/common';
import { handleRemoveConnected } from '../../utilities/Nodes/commonFunctions';
import { useFlowDataContext } from '../../context/workbench/FlowDataContext';
import { useViewPortContext } from '../../context/workbench/ViewPortContext';
import { usePermission } from '../../hooks/usePermission';

const ChoiceNode = ({ data, id }: ChoiceNodeProps) => {
    const flowDataContext = useFlowDataContext();
    const viewPortContext = useViewPortContext();

    const [visible, setVisible] = useState(false);
    const { canView, canEdit } = usePermission();

    const nextNode = useMemo(() => findNextNode(id, flowDataContext?.edges, flowDataContext?.nodes), [flowDataContext?.edges, flowDataContext?.nodes, id]);

    useEffect(() => {
        setVisible(false);
    }, [viewPortContext?.viewportXvalue, viewPortContext?.viewportYvalue])

    const handleAdd = useCallback((type: string) => {
        if (typeof data.onAdd === 'function') {
            data.onAdd(id, type);
        } else {
            console.error('onAdd is not a function:', data.onAdd);
        }
        setVisible(false);
    }, [data, id]);

    const handleVisibleChange = useCallback((newVisible: boolean) => {
        setVisible(newVisible);
    }, []);

    const content = (
        <div className="add-options-menu">
            <Button
                className="add-option-item"
                onClick={() => handleAdd('question')}
            >
                <span>question</span>
            </Button>
            <Button
                className="add-option-item"
                onClick={() => handleAdd('answer')}
            >
                <span>answer</span>
            </Button>
        </div>
    );

    return (
        <div className="add-button-container">
            <div className={nextNode ? "add-button-node choice yes" : "add-button-node choice no"}>
                <p className={(data?.label === "yes" || nextNode?.data?.buttonType === "yes") ? "mb-0 button-text yes" : "mb-0 button-text no"}>{data?.label}</p>
                {canView && canEdit && (
                    <>
                        <Popover
                            content={content}
                            trigger="hover"
                            placement="right"
                            arrow={false}
                            open={visible}
                            onOpenChange={handleVisibleChange}
                            overlayClassName="add-node-popover"
                        >
                            {nextNode === null ? <Image src={addIcon} alt="addIcon" className="addIcon pe-2" /> : ''}
                        </Popover>
                        {nextNode ? <Image src={removeIcon} alt="removeIcon" className="removeIcon pe-2" onClick={() => { handleRemoveConnected(data, id) }} /> : ''}
                    </>
                )}
            </div>
            <Handle type="target" position={Position.Left} className="handle" />
            <Handle type="source" position={Position.Right} className="handle" />
        </div>
    );
};

export default memo(ChoiceNode);
